export const GET_REGIONS = "GET_REGIONS";
export const SET_REGIONS = "SET_REGIONS";
